<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <div class="m-b-md">
        <h2 style="font-weight: bold">{{ $t("school_name") }}</h2>

        <v-card style="min-width: 400px">
          <progress-bar :show="busy"></progress-bar>
          <form @submit.prevent="login" @keydown="form.onKeydown($event)">
            <v-card-title>
              <h3>{{ $t("login") }}</h3>
            </v-card-title>

            <v-card-text>
              <!-- Email -->
              <!-- <email-input
                :form="form"
                :label="$t('email')"
                :v-errors="errors"
                :value.sync="form.email"
                name="email"
                prepend="person_outline"
                v-validate="'required|email'"
              ></email-input> -->

              <text-input
                :form="form"
                label="Email/Phone"
                :v-errors="errors"
                :value.sync="form.email"
                name="email"
                prepend="person_outline"
                v-validate="'required'"
              ></text-input>

              <!-- Password -->
              <password-input
                :v-errors="errors"
                :form="form"
                :value.sync="form.password"
                prepend="lock_outline"
                v-validate="'required|min:8'"
              ></password-input>

              <!-- Remember Me -->
              <v-checkbox
                :label="$t('remember_me')"
                color="primary"
                type="checkbox"
                v-model="remember"
                value="true"
              ></v-checkbox>

              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <router-link :to="{ name: 'password.request' }">{{
                    $t("forgot_password")
                  }}</router-link>
                  <!-- <a href>Forgot Password</a> &nbsp
                  <a href>Register</a>-->
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <submit-button
                    :block="true"
                    :form="form"
                    :label="$t('login')"
                    style="margin: 0 auto"
                  ></submit-button>
                </v-flex>
                <!-- <v-flex xs12 sm12 md12>
                  <v-btn
                    color="orange darken-4"
                    style="color: #fff"
                    @click="showP = !showP"
                  >
                    <v-icon>phone_iphone</v-icon>
                    <!-- <v-icon>credit_card</v-icon> --
                    Pay Fees Online</v-btn
                  >
                </v-flex> -->
              </v-layout>
            </v-card-text>
            <!-- <v-card-actions>
              <!-- <router-link :to="{ name: 'register' }">
              {{ $t('register') }}
              </router-link>--
              <v-spacer></v-spacer>
              <router-link :to="{ name: 'password.request' }">{{ $t('forgot_password') }}</router-link>
            </v-card-actions>-->
          </form>
        </v-card>
        <h5>
          &copy SchoolGP v1.6 by
          <a href="mailto:gopear.technologies@gmail.com">GoPear Technologies</a>
        </h5>
      </div>
    </div>

    <!-- Fees payment dialog -->
    <au-dialog pers title="Online Fees Payment" :show="showP">
      <template v-slot:header-actions>
        <v-btn @click="showP = !showP" icon style="cursor: pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <template v-slot:content>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field
              label="Enter Student's ID"
              prepend-icon="how_to_reg"
              v-model="ofp_model.sid"
              hint="Note: <li>Please press the enter key after entry to load you ward's details</li><li>Please check your ward details before making payment</li>"
            ></v-text-field>
          </v-flex>

          <v-flex xs6>
            <v-select
              label="Pay with:"
              :prepend-icon="
                ofp_model.mop == 'Mobile Money' ? 'phone_iphone' : 'credit_card'
              "
              :items="['Mobile Money']"
              v-model="ofp_model.mop"
            ></v-select>
          </v-flex>
          
          <v-flex xs12 v-if="ofp_model.sid != ''">
            <v-card v-if="ofp_model.mop == 'Mobile Money'" class="elevation-0">
              <v-card-text>
                <v-layout row wrap>
                   <v-flex xs12 md5>
                    <v-card class="elevation-1" style="margin-right: 5px">
                      <v-card-title><h4>Student Details</h4></v-card-title>
                      <v-divider></v-divider>
                      <v-card-text style="text-align: center" v-if="loadings">
                        <v-progress-circular
                          :indeterminate="true"
                          :rotate="0"
                          :size="100"
                          :value="''"
                          :width="3"
                          color="light-blue"
                          >{{
                            "loading student details..."
                          }}</v-progress-circular
                        >
                      </v-card-text>
                      <v-card-text v-else>
                        <p>
                          <span style="font-weight: bold">Name:</span>
                          Emmanuel Boahen
                        </p>
                        <p>
                          <span style="font-weight: bold">Class:</span> Basic 1
                        </p>
                        <p>
                          <span style="font-weight: bold">Arrears:</span> GHS
                          200.50
                        </p>
                        <p>
                          <span style="font-weight: bold">Guardian:</span>
                          (George Boahen - 0545254104)
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 md7>
                    <v-select
                      label="Select Your Mobile Network:"
                      prepend-icon="signal_cellular_alt"
                      :items="networks"
                      item-text="name"
                      item-value="code"
                      v-model="ofp_model.r_switch"
                    ></v-select>
                    <v-text-field
                      label="Enter Your Phone Number"
                      prepend-icon="dialpad"
                      v-model="ofp_model.subscriber_number"
                    ></v-text-field>
                    <v-text-field
                      label="Enter Your Voucher Code"
                      prepend-icon="tag"
                      v-model="ofp_model.voucher_code"
                      v-if="ofp_model.r_switch == 'VDF'"
                    ></v-text-field>

                    <v-text-field
                      label="Enter Amount (GHS)"
                      prepend-icon="money"
                      v-model="ofp_model.amount"
                    ></v-text-field>
                  </v-flex>
                 
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </template>

      <template v-slot:footer-actions>
        <v-spacer></v-spacer>
        <v-btn style="cursor: pointer" color="error" @click="showP = !showP">
          Exit
        </v-btn>
        <v-btn style="cursor: pointer" color="success" @click="payFees()">
          Pay
        </v-btn>
      </template>
    </au-dialog>
  </div>
</template>

<script>
import Form from "vform";
import Modal from "../../components/Modal.vue";
import { mapGetters } from "vuex";

export default {
  name: "admin-login-view",
  components: {
    "au-dialog": Modal,
  },
  data: () => ({
    networks: [
      { code: "MTN", name: "MTN" },
      { code: "VDF", name: "Vodafone" },
      { code: "ATL", name: "Airtel" },
      { code: "TGO", name: "Tigo" },
    ],
    loadings: false,
    ofp_model: {
      //online fees payment (ofp) model
      mop: "Mobile Money",
      sid: "",
      merchant_id: "",
      transaction_id: "",
      processing_code: "000200",
      r_switch: "",
      subscriber_number: "",
      amount: "",
      desc: "",
      voucher_code: "",
    },
    form: new Form({
      email: "",
      password: "",
    }),
    eye: true,
    remember: false,
    busy: false,
    showP: false,
  }),
  computed: {
    ...mapGetters({
      user: "authUser",
    }),
  },
  mounted() {
    this.$store.dispatch("logout");
  },
  methods: {
    async login() {
      if (await this.formHasErrors()) return;
      this.busy = true;

      // Submit the form.
      const { data } = await this.form.post("/api/login");

      // Save the token.
      this.$store.dispatch("saveToken", {
        token: data.token,
        remember: this.remember,
      });

      // Fetch the user.
      await this.$store.dispatch("fetchUser");
      this.busy = false;

      //console.log(user)
      if (this.user.status == 0) {
        this.$store.dispatch("responseMessage", {
          type: "error",
          text: "Sorry your account is disabled. Kindly contact administrator.",
          title: "Back-Office Login",
          modal: false,
        });
        await this.$store.dispatch("logout");
        return;
      }
      let user_roles = this.user.roles;

      if (user_roles) {
        for (var i = 0; i < user_roles.length; i++) {
          if (user_roles[i].name == "administrator") {
            this.$router.push(this.$route.query.redirect || "/admin");
            break;
          } else if (user_roles[i].name == "accountant") {
            this.$router.push(this.$route.query.redirect || "/accountant");
            break;
          } else if (user_roles[i].name == "teacher") {
            this.$router.push(this.$route.query.redirect || "/teacher");
            break;
          } else if (user_roles[i].name == "guardian") {
            this.$router.push(this.$route.query.redirect || "/guardian");
            break;
          } else {
            this.$store.dispatch("responseMessage", {
              type: "error",
              text: "Sorry your account is unauthorized for this request.",
              title: "Back-Office Login",
              modal: false,
            });
            await this.$store.dispatch("logout");
            break;
          }
        }
      }

      // Redirect home.
      //this.$router.push({ name: 'home' })
    },
    payFees() {
      console.log("fees_payed");
      alert("fees_payed");
    },
  },
};
</script>


<style scoped>
.full-height {
  height: 100vh;
}

.flex-center {
  align-items: center;
  display: flex;
  justify-content: center;
}

.position-ref {
  position: relative;
}

.top-right {
  position: absolute;
  right: 10px;
  top: 18px;
}

.content {
  text-align: center;
}

.title {
  font-size: 60px;
}

.links > a {
  color: #636b6f;
  padding: 0 25px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1rem;
  text-decoration: none;
  text-transform: uppercase;
}

.m-b-md {
  margin-bottom: 30px;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/adminlogin.vue